export interface PasswordChangeForm {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const validatePasswordChange = (form: PasswordChangeForm) => {
  const currentPassword = form.currentPassword.trim();
  const newPassword = form.newPassword.trim();
  const confirmPassword = form.confirmPassword.trim();

  if (!currentPassword || !newPassword || !confirmPassword) {
    return '현재 비밀번호와 새 비밀번호를 모두 입력해주세요.';
  }

  if (newPassword !== confirmPassword) {
    return '새 비밀번호와 확인 값이 일치하지 않습니다.';
  }

  if (currentPassword === newPassword) {
    return '새 비밀번호는 현재 비밀번호와 다르게 입력해주세요.';
  }

  return null;
};
